import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthService } from '../../../service';
import { useSearchQuery } from '../../../../shared/hooks/useSearchQuery';
import { ErrorToast, SuccessToast } from '../../../../utils/toasters';
import { useNavigate } from 'react-router-dom';
import registrationSlice from '../../../../store/register/brand/registrationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../store/rootReducer';
import { Col, Form, Row } from 'react-bootstrap';
import { IRegisterStepperProps } from '../../../../model/shared/IRegistration';
import { IRegistrationStepTwoRequest } from '../../brand/dto/IRegistrationStepTwoRequest';
import { StepperButtons } from '../../brand/components/StepperButtons';
import VerificationField from '../../brand/components/VerificationField';

export const StepTwo = ({ stepIdNumber, handleBackStep }: IRegisterStepperProps) => {
    const savedData = useSelector((state: IAllStates) => state.registration);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const token = useSearchQuery('token') as string;
    const utmCampaign = localStorage.getItem('utmCampaign') as string;

    const [confirmationToken, setConfirmationToken] = useState<IRegistrationStepTwoRequest>({
        confirmationToken: '',
        utmCampaign,
    });

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setConfirmationToken(prev => ({ ...prev, [name]: value }));
    };

    const handleNextStep = () => {
        AuthService.verifyUserData(token, confirmationToken)
            .then(response => {
                if (response) {
                    navigate(`/global-discovery/register/step/${stepIdNumber + 1}?token=${response?.verificationUUID}`);
                    localStorage.removeItem('utmCampaign');
                    SuccessToast(t('auth.register.brand.step2.successCode'));
                }
            })
            .catch(error => ErrorToast(error));
    };

    const resendVerify = () => {
        setIsLoading(true);
        AuthService.resetVerifyCode(savedData?.email)
            .then(() => {
                SuccessToast(t('auth.register.brand.step1.pleaseCheckEmail'));
            })
            .catch(error => ErrorToast(error))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        if (!!token?.length) {
            AuthService.getUserDataById('registerDiscovery', token)
                .then(response => {
                    dispatch(registrationSlice.actions.setRegisterUser(response));
                })
                .catch(error => ErrorToast(error));
        }
    }, [token]);

    useEffect(() => {
        if (savedData?.isEnabled) {
            navigate(`/global-discovery/register/step/${stepIdNumber + 1}?token=${savedData?.verificationUUID}`);
        }
    }, [savedData]);

    return (
        <Form
            className="w-100"
            onSubmit={e => {
                e.preventDefault();
                handleNextStep();
            }}
        >
            <Row className="justify-content-center">
                <Col xs={12}>
                    <h3>{t('auth.register.brand.step2.verify')}</h3>
                    <p className="text-muted mb-4">
                        {t('auth.register.brand.step2.verifyDescription', {
                            emailAddress: savedData?.email,
                        })}
                    </p>
                </Col>
                <VerificationField
                    changeHandler={changeHandler}
                    resendVerify={resendVerify}
                    isLoading={isLoading}
                    confirmationToken={confirmationToken?.confirmationToken}
                />
                <Col xs={12} className="mt-4">
                    <StepperButtons
                        currentStep={stepIdNumber - 1}
                        handleNextStep={handleNextStep}
                        isBackHidden={true}
                        handleBackStep={handleBackStep}
                    />
                </Col>
            </Row>
        </Form>
    );
};
